export default {"src":"/_next/static/media/eggs.5ee5a164.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};